export const createToast = (toast) => {
    const event = new CustomEvent('add-trust-toast', {
        detail: toast,
        bubbles: true,
        composed: true,
    });
    document.dispatchEvent(event);
};
//# sourceMappingURL=toastUtil.js.map